import { State } from '../../interfaces/State';
import { ImagesState } from '../reducers/images';

export const selectImages = (state: State): ImagesState => state.get('images');
